export default __webpack_public_path__ + "static/media/digital_platforms_l.be9ef374.jpg";